import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { partnerApiPath } from '../apiPath';
import { partnerHttpClient } from '../httpClient';
import { CuratorWishlistPlatformSchema } from './curatorWishlist.schema';

const DeleteCuratorWishlistRequestSchema = z
  .object({
    curatorId: z.string().min(1),
    platform: CuratorWishlistPlatformSchema,
    brandId: z.string().min(1),
  })
  .describe('DeleteCuratorWishlistRequestSchema');

export type DeleteCuratorWishlistRequest = z.infer<typeof DeleteCuratorWishlistRequestSchema>;

const DeleteCuratorWishlistResponseSchema = z.unknown();

export type DeleteCuratorWishlistResponse = z.infer<typeof DeleteCuratorWishlistResponseSchema>;

export const deleteCuratorWishlist = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(DeleteCuratorWishlistRequestSchema),
    async ({ curatorId, platform, brandId }: DeleteCuratorWishlistRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.delete<DeleteCuratorWishlistResponse>(
          partnerApiPath.curatorWishlist(curatorId),
          { platform, brandId },
        ),
      ),
    validateApiResponse(DeleteCuratorWishlistResponseSchema),
  ),
);
